import { SectionType } from '@/typings/enums/enums';
import { ActionContext, ActionTree } from 'vuex';
import { EditingState } from '@/store/modules/editing/state';
import { RootState } from '@/store/state';
import { ActiveModelPayload, ContextMenuPayload } from '@/store/modules/editing/types';
import { ModelTypes } from '@/typings/types/types';
import { SectionBaseModel } from '@/components/layout/section/SectionBaseModel';

type EditingActionContext = ActionContext<EditingState, RootState>;

export type Actions = {
  setNavigatorActiveState(context: EditingActionContext, activeState: boolean): void;
  setNavigatorTabCategory(context: EditingActionContext, activeTab: SectionType): void;
  setSelectedContextItem(context: EditingActionContext, item: ModelTypes): void;
  showContextMenu(context: EditingActionContext, payload: ContextMenuPayload): void;
  hideContextMenu(context: EditingActionContext): void;
  setActiveModel(context: EditingActionContext, payload: ActiveModelPayload): void;
  removeActiveModel(context: EditingActionContext): void;
  setCurrentActiveNavigatorID(context: EditingActionContext, payload: string | number): void;
  removeCurrentActiveNavigatorID(context: EditingActionContext): void;
  clearActiveTabCategory(context: EditingActionContext): void;
  setDefaultTabCategory(context: EditingActionContext): void;
  setSectionWithGame(context: EditingActionContext, payload: SectionBaseModel): void;
};

export const actions: ActionTree<EditingState, RootState> & Actions = {
  setNavigatorActiveState: ({ commit }, activeState: boolean) => {
    commit('setNavigatorActiveState', activeState);
  },
  setNavigatorTabCategory: ({ commit }, activeTab: SectionType) => {
    commit('setNavigatorTabCategory', activeTab);
  },
  setSelectedContextItem: ({ commit }, item: ModelTypes) => {
    commit('setSelectedContextItem', item);
  },
  showContextMenu: ({ commit }, payload: ContextMenuPayload) => {
    commit('onShowContextMenu', payload);
  },
  hideContextMenu: ({ commit }) => {
    commit('onHideContextMenu');
  },
  setActiveModel: ({ commit }, payload: ActiveModelPayload) => {
    commit('setActiveModel', payload);
  },
  removeActiveModel: ({ commit }) => {
    commit('removeActiveModel');
  },
  setCurrentActiveNavigatorID: ({ commit }, payload) => {
    commit('setCurrentActiveNavigatorID', payload);
  },
  removeCurrentActiveNavigatorID: ({ commit }) => {
    commit('removeCurrentActiveNavigatorID');
  },
  clearActiveTabCategory: ({ commit }) => {
    commit('clearActiveTabCategory');
  },
  setDefaultTabCategory: ({ commit }) => {
    commit('setDefaultTabCategory');
  },
  setSectionWithGame: ({ commit }, payload) => {
    commit('setSectionWithGame', payload);
  }
};
